import type { GridFilterOperator, GridFilterPanelProps } from "@mui/x-data-grid-pro";
import { getGridDateOperators } from "@mui/x-data-grid-pro";
import { DeliveryDateTimeFilterInput } from "@/app2/pages/ManagerView/Pages/Announcements/DeliveryDateTimeFilterInput";
import { DeliveryDateOnlyFilterInput } from "@/app2/pages/ManagerView/Pages/Announcements/DeliveryDateOnlyFilterInput";

/** Server-side filters only; client `getApplyFilterFn` must be disabled. Same as `scheduledDeliveryDate` in AnnouncementsListGrid. */
export const serverSideDateTimeFilterOperators = getGridDateOperators(true).map((op) => ({
	...op,
	getApplyFilterFn: () => null,
	...(op.InputComponent ? {InputComponent: DeliveryDateTimeFilterInput} : {}),
})) as GridFilterOperator<any, any>[];

/**
 * Date calendar only (no time): same MUI `DatePicker` + field styling as delivery filters, not native `<input type="date" />`.
 * For `hireDate` / `titleStartDate` on user lists.
 */
export const serverSideDateOnlyFilterOperators = getGridDateOperators(false).map((op) => ({
	...op,
	getApplyFilterFn: () => null,
	...(op.InputComponent ? {InputComponent: DeliveryDateOnlyFilterInput} : {}),
})) as GridFilterOperator<any, any>[];

/** Filter panel input styling aligned with AnnouncementsListGrid delivery date column. */
export const serverSideDateTimeFilterPanelProps: Pick<GridFilterPanelProps, "filterFormProps"> = {
	filterFormProps: {
		valueInputProps: {
			sx: {
				"& input[type='date'], & input[type='datetime-local']": {
					accentColor: "#FF9E00",
				},
				"& input[type='date']::-webkit-calendar-picker-indicator, & input[type='datetime-local']::-webkit-calendar-picker-indicator":
					{
						filter: "invert(0.5)",
						opacity: 1,
						cursor: "pointer",
					},
			},
		},
	},
};
